import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { HomeComponent } from './home-page/home.component';
import { WebHostingComponent } from './web-hosting-page/web-hosting.component';
import { WebHostingPymeComponent } from './web-hosting-pyme-page/web-hosting-pyme.component';
import { VirtualizacionComponent } from './virtualizacion-page/virtualizacion.component';
import { ServidoresDedicadosComponent } from './servidores-dedicados-page/servidores-dedicados.component';
import { HostingResellerComponent } from './hosting-reseller-page/hosting-reseller.component';
import { PagaDeudaComponent } from './paga-deuda/paga-deuda.component';
import { EmpresaShellComponent } from './empresa-page/empresa-shell/empresa-shell.component';
import { EmpresaNosotrosComponent } from './empresa-page/empresa-nosotros/empresa-nosotros.component';
import { EmpresaDataCenterComponent } from './empresa-page/empresa-data-center/empresa-data-center.component';
import { EmpresaFormasPagoComponent } from './empresa-page/empresa-formas-pago/empresa-formas-pago.component';
import { ErrorPageComponent } from './error-page/error-page.component';

const BUILD_COUNTRY: string = 'ar';
const SHOULD_INCLUDE_PAYMENT_ROUTE = BUILD_COUNTRY === 'cl' || BUILD_COUNTRY.startsWith('LANG_');

export const routes: Routes = [
  { path: '', component: HomeComponent },
  { path: 'web-hosting', component: WebHostingComponent },
  { path: 'web-hosting-pyme', component: WebHostingPymeComponent },
  { path: 'hosting-reseller', component: HostingResellerComponent },
  { path: 'virtualizacion', component: VirtualizacionComponent },
  { path: 'servidores-dedicados', component: ServidoresDedicadosComponent },
  ...(SHOULD_INCLUDE_PAYMENT_ROUTE ? [{ path: 'paga-deuda', component: PagaDeudaComponent }] : []),
  {
    path: 'empresa',
    component: EmpresaShellComponent,
    children: [
      { path: '', pathMatch: 'full', redirectTo: 'nosotros' },
      { path: 'nosotros', component: EmpresaNosotrosComponent, data: { animation: 'Nosotros' } },
      { path: 'data-center', component: EmpresaDataCenterComponent, data: { animation: 'DataCenter' } },
      {
        path: 'formas-pago',
        component: EmpresaFormasPagoComponent,
        data: { animation: 'FormasPago' }
      }
    ]
  },
  { path: '**', component: ErrorPageComponent }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { scrollPositionRestoration: 'top' })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
